import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./EventHeader.module.css";
import share from "../../../../images/share2.png";
import Share from "Components/UBMeEvents/Components_UBMeEvents/share/Share";
import Modal from "Components/UBMeEvents/Components_UBMeEvents/modal/Modal";
import { axiosE } from "Service/service";
import * as constants from "Constants";
import { LazyLoadImage } from "react-lazy-load-image-component";

const EventHeader = ({
                       title,
                       eventImage,
                       eventImages,
                       EventId,
                       isLoggedIn,
                       eventData,
                       LoginPopup,
                       favoriteData,
                       AddFavorite,
                       notPublished,
                     }) => {
  const [visible, setVisible]           = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [exitIndex, setExitIndex]       = useState(null);
  const [animKey, setAnimKey]           = useState(0); // force re-trigger animation
  const autoPlayRef                     = useRef(null);

  const slides = (eventImages && eventImages.length > 0)
      ? eventImages
          .map(img => img.ImageLarge || img.ImageSmall || img.large || img.small || "")
          .filter(Boolean)
      : (eventImage ? [eventImage] : []);

  const goTo = useCallback((index) => {
    if (slides.length === 0) return;
    const next = (index + slides.length) % slides.length;
    if (next === currentIndex) return;

    setExitIndex(currentIndex);
    setAnimKey(k => k + 1); // re-trigger kenBurns on new slide
    setTimeout(() => setExitIndex(null), 1100);
    setCurrentIndex(next);
  }, [currentIndex, slides.length]);

  const goNext = useCallback(() => goTo(currentIndex + 1), [currentIndex, goTo]);
  const goPrev = useCallback(() => goTo(currentIndex - 1), [currentIndex, goTo]);

  useEffect(() => {
    if (slides.length <= 1) return;
    autoPlayRef.current = setInterval(goNext, 10000);
    return () => clearInterval(autoPlayRef.current);
  }, [goNext, slides.length]);

  useEffect(() => {
    setCurrentIndex(0);
    setExitIndex(null);
    setAnimKey(0);
  }, [EventId]);

  const shareButoon = (e) => { e.stopPropagation(); setVisible(true); };
  const closeModal  = () => setVisible(false);

  const handleClick = async (data) => {
    if (favoriteData.find((x) => x.EventId === EventId)) {
      AddFavorite([...favoriteData].filter((i) => i.EventId !== EventId));
    } else {
      AddFavorite([...favoriteData, data]);
    }
    try {
      await axiosE.post("/Event/UpdateLike", {
        EventId,
        UserId: localStorage.getItem("UserId"),
        Platform: "Web",
      });
    } catch (error) {
      console.log(error);
    }
    localStorage.removeItem("pendingUpdateEventApiCall");
  };

  useEffect(() => {
    localStorage.setItem("CurrentTimeZone", JSON.stringify(eventData?.TimeZone));
    const pending = localStorage.getItem("pendingUpdateEventApiCall")
        ? JSON.parse(localStorage.getItem("pendingUpdateEventApiCall"))
        : null;
    if (isLoggedIn && pending) {
      if (eventData?.Liked !== null && eventData?.Liked === "false") {
        handleClick(eventData);
      } else {
        AddFavorite([...favoriteData, pending]);
        localStorage.removeItem("pendingUpdateEventApiCall");
      }
    }
  }, [eventData]);

  const handleLoginCall = (type, eventId) => {
    if (!isLoggedIn) {
      localStorage.setItem("pendingUpdateEventApiCall", eventId);
      localStorage.setItem("pendingEventsButtonClick", type);
      LoginPopup(true);
    }
  };

  const getSlideClass = (index) => {
    if (index === currentIndex) return `${styles.slide} ${styles.slide_active}`;
    if (index === exitIndex)    return `${styles.slide} ${styles.slide_exit}`;
    return styles.slide;
  };

  return (
      <div className={styles.event_header}>

        {/* ── Image Slider ──────────────────────────────────────────── */}
        <div className={styles.slider_container}>

          {slides.map((src, index) => (
              <div key={index} className={getSlideClass(index)}>
                {/* Ken Burns wrapper — re-keyed to restart animation */}
                <div
                    className={styles.slide_inner}
                    key={index}
                >
                  <LazyLoadImage
                      src={src}
                      width="100%"
                      height="100%"
                      effect="blur"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                        display: "block",
                      }}
                  />
                </div>
                {/* Cinematic gradient overlay */}
                <div className={styles.slide_overlay} />
              </div>
          ))}

          {/* Left Arrow */}
          {slides.length > 1 && (
              <button
                  className={`${styles.arrow} ${styles.arrow_left}`}
                  onClick={(e) => { e.stopPropagation(); goPrev(); }}
                  aria-label="Previous image"
              >
                &#8249;
              </button>
          )}

          {/* Right Arrow */}
          {slides.length > 1 && (
              <button
                  className={`${styles.arrow} ${styles.arrow_right}`}
                  onClick={(e) => { e.stopPropagation(); goNext(); }}
                  aria-label="Next image"
              >
                &#8250;
              </button>
          )}

          {/* Lines */}
          {slides.length > 1 && (
              <div className={styles.lines}>
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`${styles.line} ${index === currentIndex ? styles.line_active : ""}`}
                        onClick={(e) => { e.stopPropagation(); goTo(index); }}
                        aria-label={`Go to image ${index + 1}`}
                    />
                ))}
              </div>
          )}
        </div>

        {visible && (
            <Modal closeModal={closeModal}>
              <Share url={`${constants.URLs.baseUrl}/event/` + EventId} />
            </Modal>
        )}

        <div className={styles.event_header_action}>
          <div className={styles.event_header_action_content}>
            {favoriteData && favoriteData.find((x) => x.EventId === EventId) ? (
                <span style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); isLoggedIn ? handleClick(eventData) : LoginPopup(true); }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="svg_select" width="32" height="32" viewBox="0 0 24 24">
                <path d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z" />
              </svg>
            </span>
            ) : (
                <span style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); isLoggedIn ? handleClick(eventData) : handleLoginCall("Like", JSON.stringify(eventData)); }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="svg" width="32" height="32" viewBox="0 0 24 24">
                <path d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z" />
              </svg>
            </span>
            )}
            <a href="#!" onClick={shareButoon} className={styles.share_event}>
              <img src={share} alt="share" className={styles.share_image} />
              <p style={{ marginRight: 0, marginBottom: 0 }}>{constants.Text.share}</p>
            </a>
          </div>
        </div>
      </div>
  );
};

export default EventHeader;
